<div class="d-flex d-flex flex-wrap">
    <div *ngFor="let img of listImageUrl" class="my-auto" style="position: relative;">
        <div class="show">
            <img src="{{img}}" alt="{{img}}" onError="this.src='../../../assets/tshirt.png';" class="imgSize cursor rounded hover-shadow"
                 (click)="openImage(img)"/>

            <div class="middle" *ngIf="showDeleteIcon">
                <a href="javascript:void(0)" (click)="onClickEmitter(img)"><i class="fa fa-window-close"></i></a>
            </div>
        </div>
    </div>
</div>
